import React, { useState } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { MdLocationOn } from "react-icons/md";
import { Col, Container, Form, Row } from "react-bootstrap";
import contactImg from "../../assets/contact-us.png";
import { toast, ToastContainer } from "react-toastify";
import style from "./Contact.module.css";

const Contact = () => {
  const [userMessage, setUserMessage] = useState({});
  console.log(userMessage);

  const handleContactFormSubmit = (event) => {
    event.preventDefault();
    const name = event.target.name.value;
    const email = event.target.email.value;
    const message = event.target.message.value;
    const contact = { name, email, message };
    setUserMessage(contact);

    event.target.reset();

    if (name && email && message) {
      notify();
    } else {
      error();
    }
  };

  const notify = () => {
    toast.success("Message Send Successfully !", {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
    });
  };
  const error = () => {
    toast.error("Please Fill Out This Field.", {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  return (
    <div className={style.contact__container}>
      <Container>
        <Row>
          <h2 className={style.contact__title}>
            Get In <span>Touch</span>
          </h2>
        </Row>
        <Row className="g-3">
          <div className={style.contact__method}>
            <Col xs={12} sm={12} md={4} lg={4} className={style.phone}>
              <span>
                <FaPhoneAlt className={style.contact__icon} />
              </span>
              <h3>Call Me</h3>
              <a target="_blank." href="tel:01623171474">
                +880 1623171474
              </a>
            </Col>

            <Col xs={12} sm={12} md={4} lg={4} className={style.email}>
              <span>
                <MdEmail className={style.contact__icon} />
              </span>
              <h3>Email</h3>

              <a
                target="_blank."
                href="https://mail.google.com/mail/?view=cm&fs=1&to=zobaerahmedzihad01@gmail.com"
              >
                zobaerahmedzihad02@gmail.com
              </a>
            </Col>

            <Col xs={12} sm={12} md={4} lg={4} className={style.location}>
              <span>
                <MdLocationOn className={style.contact__icon} />
              </span>
              <h3>Location</h3>
              <a target="_blank." href="https://goo.gl/maps/C1p2dxtz8SfceQ3B9">
                Mohammadpur , Dhaka.
              </a>
            </Col>
          </div>
        </Row>
        <Row>
          <Col ex={12} sm={12} md={6} lg={6}>
            <img
              style={{ cursor: "pointer" }}
              className="img-fluid"
              src={contactImg}
              alt="img"
            />
          </Col>
          <Col
            ex={12}
            sm={12}
            md={6}
            lg={6}
            className="d-flex align-items-center justify-content-center"
          >
            <div>
              <form onSubmit={handleContactFormSubmit}>
                <input
                  className={style.input}
                  type="text"
                  placeholder="Enter Your Name"
                  autoComplete="off"
                  name="name"
                />

                <input
                  className={style.input}
                  type="email"
                  placeholder="Enter Your Email"
                  autoComplete="off"
                  name="email"
                />
                <textarea
                  className={style.textarea}
                  name="message"
                  autoComplete="off"
                  id=""
                  cols="43"
                  rows="3"
                  placeholder="Write Anything You Want..."
                ></textarea>
                <button className={style.button}> Submit</button>
              </form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Contact;
